export function topicReadingLine() {
	const nav = document.querySelector('[data-solufy-nav], .solufy-nav');
	const bottom = nav?.getBoundingClientRect().bottom || 0;
	return Math.max(32, bottom + 32);
}

export function activeTopicIndex(sections, marker) {
	let current = 0;
	const atEnd = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
	sections.forEach((section, index) => {
		if (section && (atEnd || section.getBoundingClientRect().top <= marker)) current = index;
	});
	return current;
}

const followTargets = new WeakMap();

export function followActiveTopic(menu, link) {
	if (!link || menu.getClientRects().length === 0) return;
	let scrollable = menu;
	while (scrollable && scrollable !== document.body) {
		const style = getComputedStyle(scrollable);
		if (/(auto|scroll)/.test(style.overflowY) && scrollable.scrollHeight > scrollable.clientHeight + 1) break;
		scrollable = scrollable.parentElement;
	}
	if (!scrollable || scrollable === document.body) return;
	const container = scrollable.getBoundingClientRect();
	const active = link.getBoundingClientRect();
	const padding = 20;
	const previous = followTargets.get(scrollable);
	if (previous?.link === link && previous.height === scrollable.clientHeight && previous.width === scrollable.clientWidth) return;
	followTargets.set(scrollable, { link, height: scrollable.clientHeight, width: scrollable.clientWidth });
	if (active.top < container.top + padding || active.bottom > container.bottom - padding) {
		const offset = active.top - container.top - (scrollable.clientHeight - active.height) / 2;
		const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		scrollable.scrollTo({ top: scrollable.scrollTop + offset, behavior: reduceMotion ? 'instant' : 'smooth' });
	}
}

export function prepareTopicSidebar(menu) {
	const sidebar = menu.closest('.solufy-article-sidebar, .solufy-policy-sidebar, .service-reader__sidebar');
	if (!sidebar) return;
	sidebar.setAttribute('data-lenis-prevent', '');
}
